// extracted by mini-css-extract-plugin
export default {"amountRepaid":"PastRepayments_amountRepaid","chevron":"PastRepayments_chevron"};